module.exports = __webpack_public_path__ + "static/media/Nahida.fe684624.png";